import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Navbar = ({ onGetQuote }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-40 glass-nav bg-white/80 border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            data-testid="navbar-logo"
            className="flex items-center"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_shield-agency/artifacts/ojmr7nlc_Logo_PSI_RGB.png" 
              alt="Palmetto South Insurance" 
              className="h-10 md:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              data-testid="nav-services"
              onClick={() => scrollToSection("services")}
              className="text-foreground/80 hover:text-primary font-medium text-sm transition-colors"
            >
              Services
            </button>
            <button
              data-testid="nav-about"
              onClick={() => scrollToSection("about")}
              className="text-foreground/80 hover:text-primary font-medium text-sm transition-colors"
            >
              About Us
            </button>
            <button
              data-testid="nav-contact"
              onClick={() => scrollToSection("contact")}
              className="text-foreground/80 hover:text-primary font-medium text-sm transition-colors"
            >
              Contact
            </button>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:+18642089181"
              className="flex items-center gap-2 text-sm text-foreground/80 hover:text-primary transition-colors"
            >
              <Phone className="h-4 w-4" />
              <span>(864) 208-9181</span>
            </a>
            <Button
              data-testid="nav-get-quote-button"
              onClick={onGetQuote}
              className="rounded-full bg-accent hover:bg-accent/90 text-white px-6 hover:scale-105 transition-transform duration-200"
            >
              Get a Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-foreground"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-border"
        >
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection("services")}
              className="block w-full text-left py-2 text-foreground/80 hover:text-primary font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className="block w-full text-left py-2 text-foreground/80 hover:text-primary font-medium"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="block w-full text-left py-2 text-foreground/80 hover:text-primary font-medium"
            >
              Contact
            </button>
            <div className="pt-3 border-t border-border">
              <a
                href="tel:+18642089181"
                className="flex items-center gap-2 py-2 text-foreground/80"
              >
                <Phone className="h-4 w-4" />
                <span>(864) 208-9181</span>
              </a>
              <Button
                onClick={onGetQuote}
                className="w-full mt-3 rounded-full bg-accent hover:bg-accent/90 text-white"
              >
                Get a Quote
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
